/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const Language = {
    KK: 'KK',
    RU: 'RU',
    EN: 'EN',
    UZ: 'UZ',
    KG: 'KG',
    TG: 'TG'
} as const;
export type Language = typeof Language[keyof typeof Language];

